import { useQuery } from "@tanstack/react-query";
import userService from "../../../../services/web/user-service.js";
import natureService from "../../../../services/web/nature-service.js";
import corporationService from "../../../../services/web/corporation-service.js";
import janitorialService from "../../../../services/web/janitorial-service.js";
import equipmentsService from "../../../../services/web/equipments-service.js";
import placeService from "../../../../services/web/place-service.js";

export const useJanitorialQueries = (id) => {
  const hasValidJanitorialId = Number.isInteger(Number(id)) && Number(id) > 0;

  const { data: agents = [], isLoading: isLoadingAgents } = useQuery({
    queryFn: userService.getAgents,
    select: data => data.map(agent => ({ value: agent.id, label: agent.text })),
    queryKey: ['agents']
  });

  const { data: reasons = [], isLoading: isLoadingReasons } = useQuery({
    queryFn: () => natureService.getJanitorialNatures(),
    queryKey: ["reasons"]
  });

  const { data: corporation = null, isLoading: isLoadingCorporation } = useQuery({
    queryFn: () => corporationService.entity(),
    queryKey: ["corporation"]
  });

  const { data: janitorialData = null, isLoading: isLoadingJanitorial } = useQuery({
    queryFn: () => janitorialService.getById(id),
    queryKey: ['janitorial', id],
    enabled: !!id,
  });

  const { data: equipmentData = null, isLoading: isLoadingEquipmentData } = useQuery({
    queryFn: () => janitorialService.getEquipments(id),
    queryKey: ["janitorial-equipments", id],
    enabled: !!id,
  });

  const { data: currentUser } = useQuery({
    queryKey: ['loggedUser'],
    queryFn: () => userService.getUserLogged(),
    staleTime: Infinity,
  });

  const { data: getJanitorialTaskById } = useQuery({
    queryKey: ['janitorial-task', id],
    queryFn: () => janitorialService.getJanitorialTaskById(id),
    staleTime: Infinity,
    enabled: hasValidJanitorialId,
  });

  const activeTask = Array.isArray(getJanitorialTaskById)
      ? getJanitorialTaskById.find(task => task.status === true)
      : undefined;

  const { data: dispatchData } = useQuery({
    queryKey: ['janitorial-dispatch', activeTask?.id],
    queryFn: () => janitorialService.checkHasDispatch(activeTask.id),
    staleTime: Infinity,
    enabled: !!activeTask?.id,
  });

  const {data: registeredAddress = []} = useQuery({
    queryFn: placeService.allPlaces,
    select: places => places.map(place => ({value: place.id, label: place.text})),
    queryKey: ["registeredPlaces"]
  });

  const { data: equipmentsOptions = [], isLoading: isLoadingEquipmentsOptions } = useQuery({
    queryFn: equipmentsService.allEquipments,
    select: equipments => equipments.map(equipment => ({ value: equipment.id, label: equipment.text })),
    queryKey: ['equipments']
  });
  const isGlobalLoading =
    isLoadingAgents ||
    isLoadingReasons ||
    isLoadingCorporation ||
    isLoadingJanitorial ||
    isLoadingEquipmentData ||
    isLoadingEquipmentsOptions;

  return {
    agents,
    reasons,
    corporation,
    janitorialData,
    equipmentData,
    currentUser,
    equipmentsOptions,
    isGlobalLoading,
    activeTask: activeTask,
    dispatchEnabled: dispatchData,
    getJanitorialTaskById,
    registeredAddress
  };
};
